/* LCT — Fiche produit « Carte cadeau » (sections/lct-gift-card.liquid) */
if (!customElements.get('lct-gift-card')) {
  class LctGiftCard extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';

      this.form = this.querySelector('form[data-type="add-to-cart-form"]');
      this.productForm = this.querySelector('product-form');
      this.recipient = this.querySelector('[data-gc-recipient]');
      this.flag = this.querySelector('[data-gc-flag]');
      this.offset = this.querySelector('[data-gc-offset]');
      this.email = this.querySelector('[data-gc-email]');
      this.name = this.querySelector('[data-gc-name]');
      this.message = this.querySelector('[data-gc-message]');
      this.date = this.querySelector('[data-gc-date]');
      this.count = this.querySelector('[data-gc-count]');
      this.alert = this.querySelector('[data-gc-alert]');
      this.note = this.querySelector('[data-gc-note]');

      // Montants
      this.querySelectorAll('input[name="id"]').forEach((input) =>
        input.addEventListener('change', () => this.onAmountChange(input))
      );

      // Pour moi / Pour offrir
      this.querySelectorAll('input[name="lct_gc_mode"]').forEach((input) =>
        input.addEventListener('change', () => this.setMode(input.value))
      );

      // Aperçu en direct
      [this.name, this.message].forEach((field) => field?.addEventListener('input', () => this.updatePreview()));
      this.message?.addEventListener('input', () => {
        this.count.textContent = this.message.value.length;
      });
      [this.email, this.name, this.message, this.date].forEach((field) =>
        field?.addEventListener('input', () => this.clearError(field))
      );

      // Date d'envoi : d'aujourd'hui à +90 jours
      if (this.date) {
        const toIso = (d) =>
          `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
        const today = new Date();
        const max = new Date();
        max.setDate(max.getDate() + 90);
        this.date.min = toIso(today);
        this.date.max = toIso(max);
      }

      // Vérification avant l'ajout au panier (avant product-form.js)
      // (écouteur en phase de capture sur <product-form>, donc déclenché avant celui de product-form.js)
      this.productForm?.addEventListener('submit', (event) => this.validate(event), true);

      // Erreurs renvoyées par Shopify
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartError, (event) => {
          if (event.source !== 'product-form' || !this.contains(this.productForm)) return;
          this.showServerErrors(event.errors, event.message);
        });
        subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          if (event.source === 'product-form') this.hideAlert();
        });
      }

      const selected = this.querySelector('input[name="id"]:checked');
      if (selected) this.onAmountChange(selected, false);
    }

    onAmountChange(input, updateUrl = true) {
      const price = input.dataset.price;
      this.querySelectorAll('[data-gc-preview-amount], [data-gc-preview-price]').forEach((el) => {
        el.textContent = price;
      });
      const card = this.querySelector('.lct-gc__card');
      if (card && updateUrl) {
        card.classList.remove('is-bump');
        void card.offsetWidth;
        card.classList.add('is-bump');
      }
      if (updateUrl) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', input.value);
        window.history.replaceState({}, '', url.toString());
      }
    }

    setMode(mode) {
      const gift = mode === 'gift';
      this.recipient.hidden = !gift;
      this.flag.checked = gift;
      this.offset.disabled = !gift;
      if (gift) this.offset.value = new Date().getTimezoneOffset();
      [this.email, this.name, this.message, this.date].forEach((field) => {
        if (field) field.disabled = !gift;
      });
      if (gift) {
        this.slideOpen(this.recipient);
        this.email?.focus({ preventScroll: true });
      } else {
        this.recipient.querySelectorAll('[data-gc-error]').forEach((el) => (el.hidden = true));
      }
      this.updatePreview();
      this.hideAlert();
    }

    slideOpen(el) {
      if (!el.animate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const height = el.offsetHeight;
      el.style.overflow = 'hidden';
      const anim = el.animate(
        [
          { height: '0px', opacity: 0 },
          { height: `${height}px`, opacity: 1 },
        ],
        { duration: 280, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' }
      );
      anim.onfinish = anim.oncancel = () => (el.style.overflow = '');
    }

    updatePreview() {
      const gift = this.flag.checked;
      const name = this.name?.value.trim();
      const msg = this.message?.value.trim();
      const show = gift && (name || msg);
      this.note.hidden = !show;
      if (!show) return;
      const nameEl = this.note.querySelector('[data-gc-preview-name]');
      const toEl = this.note.querySelector('.lct-gc__note-to');
      nameEl.textContent = name;
      toEl.hidden = !name;
      const msgEl = this.note.querySelector('[data-gc-preview-msg]');
      msgEl.textContent = msg ? `« ${msg} »` : '';
      msgEl.hidden = !msg;
    }

    validate(event) {
      this.hideAlert();
      if (!this.flag.checked) return;
      const value = this.email.value.trim();
      let error = '';
      if (!value) error = "Indiquez l'e-mail du destinataire.";
      else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) error = "Cette adresse e-mail n'est pas valide.";
      if (!error) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      this.showError('email', error);
      this.email.focus();
    }

    showError(key, text) {
      const el = this.querySelector(`[data-gc-error="${key}"]`);
      const field = { email: this.email, name: this.name, message: this.message, send_on: this.date }[key];
      if (el) {
        el.textContent = text;
        el.hidden = false;
      }
      field?.setAttribute('aria-invalid', 'true');
    }

    clearError(field) {
      field.removeAttribute('aria-invalid');
      const key = { [this.email?.id]: 'email', [this.name?.id]: 'name', [this.message?.id]: 'message', [this.date?.id]: 'send_on' }[field.id];
      const el = key && this.querySelector(`[data-gc-error="${key}"]`);
      if (el) el.hidden = true;
    }

    showServerErrors(errors, message) {
      let shown = false;
      if (errors && typeof errors === 'object') {
        Object.entries(errors).forEach(([key, value]) => {
          const text = Array.isArray(value) ? value.join(' ') : String(value);
          if (this.querySelector(`[data-gc-error="${key}"]`)) {
            this.showError(key, text);
            shown = true;
          }
        });
      }
      if (!shown) {
        this.alert.textContent =
          (typeof errors === 'string' && errors) || message || 'Une erreur est survenue, veuillez réessayer.';
        this.alert.hidden = false;
      }
    }

    hideAlert() {
      if (this.alert) this.alert.hidden = true;
    }
  }

  customElements.define('lct-gift-card', LctGiftCard);
}
